import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { commonStyles } from '../../styles/common';

interface TextButtonProps {
  to?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const TextButton: React.FC<TextButtonProps> = ({ to, children, onClick }) => {
  const buttonProps = {
    variant: 'text' as const,
    color: 'primary' as const,
    onClick,
    sx: commonStyles.textButton,
  };

  if (to) {
    return (
      <Button
        component={Link}
        to={to}
        {...buttonProps}
      >
        {children}
      </Button>
    );
  }

  return <Button {...buttonProps}>{children}</Button>;
};

export default TextButton; 